
const CONSENT_KEY = 'cookie_consent'

export const CookieConsentService = {
    getConsent() {
        const stored = localStorage.getItem(CONSENT_KEY)
        if (!stored) return null
        try {
            return JSON.parse(stored)
        } catch (e) {
            return null
        }
    },

    setConsent(consent) {
        const value = {
            necessary: true, // Always true
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            timestamp: new Date().toISOString()
        }
        localStorage.setItem(CONSENT_KEY, JSON.stringify(value))

        // Trigger event for immediate reaction if needed
        window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: value }))
    },

    resetConsent() {
        localStorage.removeItem(CONSENT_KEY)
    },

    hasConsented() {
        return !!localStorage.getItem(CONSENT_KEY)
    }
}
